import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgTextVisibilityOn = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	width: 23,
	height: 16,
	viewBox: "0 0 23 16",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [
		title ? /* @__PURE__ */ _jsx("title", {
			id: titleId,
			children: title
		}) : null,
		/* @__PURE__ */ _jsx("path", {
			d: "M20.6303 5.8531C21.7899 7.07317 21.7899 8.92683 20.6303 10.1469C18.6745 12.2047 15.3155 15 11.5 15C7.68448 15 4.32549 12.2047 2.36971 10.1469C1.2101 8.92683 1.2101 7.07317 2.36971 5.8531C4.32549 3.79533 7.68448 1 11.5 1C15.3155 1 18.6745 3.79533 20.6303 5.8531Z",
			stroke: "currentColor",
			strokeWidth: 1.5
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M14.5 8C14.5 9.65685 13.1569 11 11.5 11C9.84315 11 8.5 9.65685 8.5 8C8.5 6.34315 9.84315 5 11.5 5C13.1569 5 14.5 6.34315 14.5 8Z",
			stroke: "currentColor",
			strokeWidth: 1.5
		})
	]
});
const ForwardRef = forwardRef(SvgTextVisibilityOn);
export default ForwardRef;
